import each from './functions/each';
/**
 * 为了使用模块扩充，这里不能使用默认导出
 */
export class JQ {
    constructor(arr) {
        this.length = 0;
        if (!arr) {
            return this;
        }
        each(arr, (i, item) => {
            // @ts-ignore
            this[i] = item;
        });
        this.length = arr.length;
        return this;
    }
}
